module.exports = __webpack_public_path__ + "img/高拍仪.faa668d9.jpg";